import React from 'react';
import DistributionBarCard from './DistributionBarCard';

const satisfactionColor = (rating) => {
  if (rating >= 5) return 'fi-bar-green';
  if (rating >= 4) return 'fi-bar-lime';
  if (rating >= 3) return 'fi-bar-yellow';
  if (rating >= 2) return 'fi-bar-orange';
  return 'fi-bar-red';
};

const OverallSatisfactionCard = ({ items = [], totalResponses = 0 }) => {
  const ratings = [5, 4, 3, 2, 1].map((rating) => {
    const match = items.find((item) => Number(item.rating) === rating);
    return {
      rating,
      count: Number(match?.count ?? 0),
      percentage: Number(match?.percentage ?? 0),
    };
  });

  return (
    <DistributionBarCard
      title="Overall Satisfaction"
      subtitle="(Q1)"
      icon="★"
      items={ratings}
      getLabel={(item) => `${item.rating} stars`}
      getCount={(item) => item.count}
      getPercentage={(item) => item.percentage}
      getBarClass={(item) => satisfactionColor(item.rating)}
      footer={
        totalResponses === 0 ? (
          <p className="fi-empty-inline">No satisfaction ratings yet.</p>
        ) : null
      }
    />
  );
};

export default OverallSatisfactionCard;
